// extracted by mini-css-extract-plugin
export default {"form":"CompanyAccountForm_form__Eunzv"};